/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Toasttitle2Inputs */

const he_ratelimit_toasttitle2 = /** @type {(inputs: Ratelimit_Toasttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האט, מהיר מדי!`)
};

const en_ratelimit_toasttitle2 = /** @type {(inputs: Ratelimit_Toasttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slow down, speedster!`)
};

/**
* | output |
* | --- |
* | "Slow down, speedster!" |
*
* @param {Ratelimit_Toasttitle2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_toasttitle2 = /** @type {((inputs?: Ratelimit_Toasttitle2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Toasttitle2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_toasttitle2(inputs)
	return en_ratelimit_toasttitle2(inputs)
});
export { ratelimit_toasttitle2 as "rateLimit_toastTitle" }